// Module
var code = "<md-icon ng-if=\"$ctrl.relationList.length\" id=\"expend-icon\" ng-click=\"$ctrl.onExpand(); $event.stopPropagation()\" md-svg-icon=\"{{$ctrl.isExpended? 'minimize': 'maximize'}}\"> </md-icon> ";
// Exports
export default code;